import { useMemo } from 'react';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import Selectors from 'feedback-public-submission-ui/constants/Selectors';
import ErrorState from 'feedback-public-submission-ui/components/ErrorState';
import SurveyFooter from 'feedback-public-submission-ui/components/SurveyFooter';
import { useSubmissionUpdates } from 'feedback-public-submission-ui/hooks/useSubmissionUpdates';
import { getShouldShowThankYou } from 'feedback-public-submission-ui/utils/getShouldShowThankYou';
import ThankYouTile from 'feedback-public-submission-ui/components/ThankYouTile';
import FeedbackTile from 'feedback-public-submission-ui/components/FeedbackTile';
import { areParamsValid } from 'feedback-public-submission-ui/utils/areParamsValid';
import { useSurveyConfig } from 'feedback-public-submission-ui/hooks/useSurveyConfig';
import { getSurveyConfigErrorType } from 'feedback-public-submission-ui/utils/getSurveyConfigErrorType';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SurveyContents = ({
  changeStage,
  device,
  feedbackResponse,
  params,
  surveyType
}) => {
  const {
    error,
    isFetched,
    surveyConfig
  } = useSurveyConfig();
  const isParamsValid = useMemo(() => areParamsValid(params), [params]);
  const errorType = useMemo(() => getSurveyConfigErrorType(error, feedbackResponse, isParamsValid), [error, feedbackResponse, isParamsValid]);
  const {
    contactProperties,
    isThankYouPreview,
    onFollowUpChange,
    onRatingChange,
    onSubmit
  } = useSubmissionUpdates();
  const showThankYou = getShouldShowThankYou({
    feedbackResponse,
    isThankYouPreview,
    params,
    surveyConfig
  });
  if (errorType) {
    return /*#__PURE__*/_jsx(ErrorState, {
      errorType: errorType,
      surfaceError: !!params.surfaceError
    });
  } else if (!isFetched || !surveyConfig.strings) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      showLabel: false
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-test": Selectors.HOMEPAGE,
    id: "homepage",
    children: /*#__PURE__*/_jsxs("div", {
      className: "wrapper",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          backgroundColor: surveyConfig.themeColor,
          height: '30%'
        }
      }), /*#__PURE__*/_jsxs("div", {
        className: "content",
        children: [showThankYou && /*#__PURE__*/_jsx(ThankYouTile, {
          selectedRating: feedbackResponse.rating,
          surveyConfig: surveyConfig,
          surveyType: surveyType
        }), !showThankYou && /*#__PURE__*/_jsx(FeedbackTile, {
          contactProperties: contactProperties,
          device: device,
          feedbackResponse: feedbackResponse,
          handleClickSubmit: () => onSubmit(changeStage)({
            feedbackResponse,
            params,
            surveyConfig,
            surveyType
          }),
          handleFollowUpChange: onFollowUpChange,
          isTest: Boolean(params.test),
          setRating: onRatingChange(changeStage),
          surveyConfig: surveyConfig,
          surveyType: surveyType
        }), /*#__PURE__*/_jsx(SurveyFooter, {
          strings: surveyConfig.strings
        })]
      })]
    })
  });
};
export default SurveyContents;